export const getCachedPatient = (state, id) => state.cache.patients[id];
export const getIsOrganizationsCached = (state) => state.cache.isOrganizationsCached;
export const getIsClientsCached = (state) => state.cache.isClientsCached;
export const getCachedPortalInvites = (state, portalPatientId) =>
  state.cache.portalInvites[portalPatientId];
export const getCachedPortalRelationStatuses = (state, portalPatientId) =>
  state.cache.portalRelationStatuses[portalPatientId];
